import styled from "styled-components";

import { windowWidth } from "@styles/global";

export const TabPanelContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  padding-left: 2px;

  @media (max-width: ${windowWidth.tablet}) {
    padding: 0 25px;
  }
`;
